
import headMobLogo from "../assets/images/logo.svg";
import UserSignature from "../components/UserSignature";
import LoginCarousel from "../components/LoginCarousel";

const LoginScreen = () => {
  return (
    <div className="login_main">
      <header className="login_mob_head">
        <img src={headMobLogo} className="log_mob-logo" alt="logo" />
      </header>
      <div className="form_main">
        <UserSignature />
      </div>
      <LoginCarousel/>
    </div>
  );
};

export default LoginScreen;